import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { useDashboard } from 'console/dashboards/z3k/provider';
import { SortablePanels } from 'console/shared/components/features/sortable-panels';
import { wrapping_element_props } from 'console/shared/components/tab/panel/utils';
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { DashboardVehicleMap } from './map';
import * as S from '../../styles';
export const DashboardVehicleDevice = memo(function DashboardVehicleDevice() {
    const { device_id } = useDeviceConfig();
    const { panels } = useDeviceUISettings();
    const { sorting_mode } = useDashboard();
    return (_jsxs(Box, { display: "grid", height: "100%", gridTemplateRows: !isMediumUI() ? '1fr 0.5fr' : '1fr', gridTemplateColumns: isMediumUI() ? '1fr 0.8fr' : '1fr', overflow: "auto", children: [_jsx(S.DeviceContent, { initial: "open", animate: "open", exit: "close", variants: wrapping_element_props.variants, transition: wrapping_element_props.transition, sorting_mode: sorting_mode, children: _jsx(SortablePanels, { list: panels }) }, `dashboard-device-content-${device_id}`), _jsx(DashboardVehicleMap, { device_id: device_id })] }));
});
